import type { GeneratedContent } from "../types";

interface FooterSectionProps {
  content: GeneratedContent;
}

export const FooterSection: React.FC<FooterSectionProps> = ({ content }) => {
  return (
    <div className="mt-12 pt-6 border-t-2 border-indigo-700 text-center text-sm text-gray-600">
      <p className="font-semibold text-indigo-900 mb-2">Bom trabalho! 📚</p>
      {content.habilidades_bncc && content.habilidades_bncc.length > 0 && (
        <p className="text-xs text-gray-700">
          <strong>Atividade alinhada à BNCC</strong>
          <br />
          Habilidades:{" "}
          {content.habilidades_bncc.map((h: any) => h.codigo).join(", ")}
        </p>
      )}
    </div>
  );
};
